module.exports = __webpack_public_path__ + "static/img/02.4455c40.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/haeusle/02.jpg
// module id = 370
// module chunks = 1